import { pgTable, integer, numeric, timestamp, foreignKey } from 'drizzle-orm/pg-core';
import { sql } from 'drizzle-orm';
import { pricingTier } from './pricing-tier';

/**
 * TierPurchaseStats — агрегированная статистика покупок по тарифу.
 *
 * Денормализованная таблица для быстрых аналитических запросов "топ тарифов",
 * "выручка по тарифу", "уникальные покупатели". Поддерживается AnalyticsDenormService:
 * при каждом подтверждении платежа upsert по tierId, при удалении тарифа запись
 * каскадно удаляется (cascade FK).
 *
 * Один к одному с PricingTier: tierId — primary key и foreign key одновременно.
 *
 * Поля:
 * - totalPurchases — общее число подтверждённых покупок (включая повторные у одного юзера)
 * - totalRevenueBase — суммарная выручка в базовой валюте аналитики
 * - uniqueBuyers — число уникальных пользователей, купивших этот тариф
 * - firstPurchaseAt / lastPurchaseAt — крайние даты покупок
 * - updatedAt — время последнего пересчёта (для мониторинга свежести данных)
 */
export const tierPurchaseStats = pgTable(
  'TierPurchaseStats',
  {
    tierId: integer().primaryKey(),
    totalPurchases: integer().default(0).notNull(),
    totalRevenueBase: numeric({ precision: 14, scale: 2 }).default('0').notNull(),
    uniqueBuyers: integer().default(0).notNull(),
    firstPurchaseAt: timestamp({ precision: 3, mode: 'date' }),
    lastPurchaseAt: timestamp({ precision: 3, mode: 'date' }),
    updatedAt: timestamp({ precision: 3, mode: 'date' })
      .default(sql`CURRENT_TIMESTAMP`)
      .notNull(),
  },
  (table) => [
    foreignKey({
      columns: [table.tierId],
      foreignColumns: [pricingTier.id],
      name: 'TierPurchaseStats_tierId_fkey',
    }).onDelete('cascade'),
  ],
);
